import { computed, defineComponent } from 'vue';
import classNames from '../../_util/classNames';
const ColorBlock = defineComponent({
    name: 'ColorBlock',
    props: ['color', 'prefixCls', 'onClick'],
    setup(props) {
        const colorBlockCls = computed(() => `${props.prefixCls}-color-block`);
        return () => (<div class={classNames(colorBlockCls.value)} onClick={props.onClick}>
        <div class={`${colorBlockCls.value}-inner`} style={{
                background: props.color,
            }}/>
      </div>);
    },
});
export default ColorBlock;
